"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ttiPolyfill = require("tti-polyfill");

var _timing = require("./timing");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DOM_COMPLETE = _timing.LoadTimeEvent.DOM_COMPLETE,
    DOM_LOADING = _timing.LoadTimeEvent.DOM_LOADING,
    DOM_CONTENT_LOADED_EVENT_START = _timing.LoadTimeEvent.DOM_CONTENT_LOADED_EVENT_START,
    DOM_CONTENT_LOADED_EVENT_END = _timing.LoadTimeEvent.DOM_CONTENT_LOADED_EVENT_END,
    LOAD_EVENT_START = _timing.LoadTimeEvent.LOAD_EVENT_START,
    LOAD_EVENT_END = _timing.LoadTimeEvent.LOAD_EVENT_END;
var FIRST_CONTENTFUL_PAINT = _timing.PaintTimeEvent.FIRST_CONTENTFUL_PAINT;

/**
 * A class to track various page load timing metrics
 * All timings recorded in milliseconds
 */
var LoadTimingTracker = /*#__PURE__*/function () {
  function LoadTimingTracker() {
    var recorders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, LoadTimingTracker);

    if (process.env.NODE_ENV !== 'production' && !recorders.length) {
      console.error('No recorders given to LoadTimingTracker. Timing data will not be recorded.');
    }

    this.profilerStart = (0, _timing.getTimeOrigin)();
    this.recorders = recorders;
  }
  /**
   * Records the time in milliseconds from the time origin at which the initial
   * HTML document has been completely loaded and parsed, without
   * waiting for stylesheets, images, and subframes to finish loading
   *
   * @param {string} category - Category in which event falls e.g. a page name like video_manager
   * @param {string} label - A label to apply e.g. associated test bucket
   */


  _createClass(LoadTimingTracker, [{
    key: "recordDOMContentLoaded",
    value: function recordDOMContentLoaded() {
      var category,
          label,
          domLoadedTime,
          _args = arguments;
      return regeneratorRuntime.async(function recordDOMContentLoaded$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              category = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              label = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
              _context.next = 4;
              return regeneratorRuntime.awrap((0, _timing.getNavigationTiming)(DOM_CONTENT_LOADED_EVENT_END));

            case 4:
              domLoadedTime = _context.sent;
              this.callRecorders(category, label, 'dom_content_loaded', domLoadedTime);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, null, Promise);
    }
    /**
     * Records the duration in milliseconds of the DOMContentLoaded event
     *
     * @param {string} category - Category in which event falls e.g. a page name like video_manager
     * @param {string} label - A label to apply e.g. associated test bucket
     */

  }, {
    key: "recordDOMContentLoadEventDuration",
    value: function recordDOMContentLoadEventDuration() {
      var category,
          label,
          domContentLoadedEndTime,
          domContentLoadedStartTime,
          eventDuration,
          _args2 = arguments;
      return regeneratorRuntime.async(function recordDOMContentLoadEventDuration$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              category = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              label = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
              _context2.next = 4;
              return regeneratorRuntime.awrap((0, _timing.getNavigationTiming)(DOM_CONTENT_LOADED_EVENT_END));

            case 4:
              domContentLoadedEndTime = _context2.sent;
              _context2.next = 7;
              return regeneratorRuntime.awrap((0, _timing.getNavigationTiming)(DOM_CONTENT_LOADED_EVENT_START));

            case 7:
              domContentLoadedStartTime = _context2.sent;
              eventDuration = domContentLoadedEndTime - domContentLoadedStartTime;
              this.callRecorders(category, label, 'dom_content_load_duration', eventDuration);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this, null, Promise);
    }
    /**
     * Records the time in milliseconds it took the page to fully load from the time origin
     * This indicates the document and all sub-resources have finished loading
     *
     * @param {string} category - Category in which event falls e.g. a page name like video_manager
     * @param {string} label - A label to apply e.g. associated test bucket
     */

  }, {
    key: "recordLoaded",
    value: function recordLoaded() {
      var category,
          label,
          domLoadedTime,
          _args3 = arguments;
      return regeneratorRuntime.async(function recordLoaded$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              category = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
              label = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : '';
              _context3.next = 4;
              return regeneratorRuntime.awrap((0, _timing.getNavigationTiming)(LOAD_EVENT_END));

            case 4:
              domLoadedTime = _context3.sent;
              this.callRecorders(category, label, 'loaded', domLoadedTime);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this, null, Promise);
    }
    /**
     * Records the duration in milliseconds of the load event
     *
     * @param {string} category - Category in which event falls e.g. a page name like video_manager
     * @param {string} label - A label to apply e.g. associated test bucket
     */

  }, {
    key: "recordLoadEventDuration",
    value: function recordLoadEventDuration() {
      var category,
          label,
          loadedStartTime,
          loadedEndTime,
          loadDuration,
          _args4 = arguments;
      return regeneratorRuntime.async(function recordLoadEventDuration$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              category = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : '';
              label = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : '';
              _context4.next = 4;
              return regeneratorRuntime.awrap((0, _timing.getNavigationTiming)(LOAD_EVENT_START));

            case 4:
              loadedStartTime = _context4.sent;
              _context4.next = 7;
              return regeneratorRuntime.awrap((0, _timing.getNavigationTiming)(LOAD_EVENT_END));

            case 7:
              loadedEndTime = _context4.sent;
              loadDuration = loadedEndTime - loadedStartTime;
              this.callRecorders(category, label, 'load_duration', loadDuration);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this, null, Promise);
    }
    /**
     * Records time in milliseconds required to render the page obtained by calculating
     * the difference of the time at which the loading of the DOM and its dependencies completes
     * and the time at which parsing of the DOM began
     *
     * @param {string} category - Category in which event falls e.g. a page name like video_manager
     * @param {string} label - A label to apply e.g. associated test bucket
     */

  }, {
    key: "recordPageRenderDuration",
    value: function recordPageRenderDuration() {
      var category,
          label,
          domLoadEvent,
          domCompleteTime,
          domLoadingTime,
          pageRenderDuration,
          _args5 = arguments;
      return regeneratorRuntime.async(function recordPageRenderDuration$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              category = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : '';
              label = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '';
              domLoadEvent = !!window.PerformanceNavigationTiming ? DOM_CONTENT_LOADED_EVENT_START : DOM_LOADING;
              _context5.next = 5;
              return regeneratorRuntime.awrap((0, _timing.getNavigationTiming)(DOM_COMPLETE));

            case 5:
              domCompleteTime = _context5.sent;
              _context5.next = 8;
              return regeneratorRuntime.awrap((0, _timing.getNavigationTiming)(domLoadEvent));

            case 8:
              domLoadingTime = _context5.sent;
              pageRenderDuration = domCompleteTime - domLoadingTime;
              this.callRecorders(category, label, 'page_render_duration', pageRenderDuration);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "recordFirstInputDelay",
    value: function recordFirstInputDelay() {
      var _this = this;

      var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var win = window;

      if (win.perfMetrics && typeof win.perfMetrics.onFirstInputDelay === 'function') {
        win.perfMetrics.onFirstInputDelay(function (delay) {
          _this.callRecorders(category, label, 'first_input_delay', delay);
        });
      }
    }
  }, {
    key: "recordFirstContentfulPaint",
    value: function recordFirstContentfulPaint() {
      var category,
          label,
          time,
          _args6 = arguments;
      return regeneratorRuntime.async(function recordFirstContentfulPaint$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              category = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : '';
              label = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : '';
              _context6.next = 4;
              return regeneratorRuntime.awrap((0, _timing.getPaintTiming)(FIRST_CONTENTFUL_PAINT));

            case 4:
              time = _context6.sent;
              this.callRecorders(category, label, 'first_contentful_paint', time);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this, null, Promise);
    }
    /**
     * The event happens when the content the user is most interested in seeing
     * has been painted to the screen
     * @param {string} category
     * @param {string} label
     */

  }, {
    key: "recordFirstMeaningfulPaint",
    value: function recordFirstMeaningfulPaint() {
      var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.recordEvent(category, label, 'first_meaningful_paint');
    }
    /**
     * Records when all meaningful elements have been painted to the screen and
     * can be interacted with by the user
     * Depends on https://github.com/GoogleChromeLabs/tti-polyfill
     * @param {string} category
     * @param {string} label
     */

  }, {
    key: "recordTimeToInteractive",
    value: function recordTimeToInteractive() {
      var category,
          label,
          tti,
          _args7 = arguments;
      return regeneratorRuntime.async(function recordTimeToInteractive$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              category = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : '';
              label = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : '';

              if (!(typeof _ttiPolyfill.getFirstConsistentlyInteractive === 'function')) {
                _context7.next = 7;
                break;
              }

              _context7.next = 5;
              return regeneratorRuntime.awrap((0, _ttiPolyfill.getFirstConsistentlyInteractive)());

            case 5:
              tti = _context7.sent;

              // tti could be null if value could not be determined or if all required
              // browser APIs are not supported
              if (typeof tti === 'number') {
                this.callRecorders(category, label, 'time_to_interactive', tti);
              }

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this, null, Promise);
    }
    /**
     * Records the elapsed time in milliseconds from profilerStart
     *
     * @param {string} category - Category in which event falls e.g. a page name like video_manager
     * @param {string} label - A label to apply e.g. associated test bucket
     * @param {string} variable - Additional information about the event e.g. event type, defaults to `load`
     */

  }, {
    key: "recordEvent",
    value: function recordEvent() {
      var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var variable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'load';
      var elapsedTime = (0, _timing.getElapsedTime)(this.profilerStart);
      this.callRecorders(category, label, variable, elapsedTime);
    }
    /**
     * Resets the profilerStart value to now
     */

  }, {
    key: "reset",
    value: function reset() {
      this.profilerStart = (0, _timing.getNow)();
    }
    /**
     * Validate data and pass to the recorders
     */

  }, {
    key: "callRecorders",
    value: function callRecorders(category, label, variable, time) {
      var hasCategory = category !== '';

      if (process.env.NODE_ENV !== 'production' && !hasCategory) {
        console.error('category is required to record a load timing event.');
      } // Do not warn about 0 values as it likely means there is no browser support for perf timings


      if (hasCategory && typeof time === 'number' && time > 0) {
        this.recorders.forEach(function (record) {
          record(category, label, variable, time);
        });
      }
    }
  }]);

  return LoadTimingTracker;
}();

var _default = LoadTimingTracker;
exports.default = _default;